export class LegalDomainModel {
  public id: number;
  public name: string;
  public isDeleted: boolean;
}




// WEBPACK FOOTER //
// ./src/app/core/models/legal-domain.Model.ts